/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../../_chunks/dep-b011b919.mjs';
import { i as isUndefined_1 } from '../../../_chunks/dep-fdde96c5.mjs';
import { i as isBoolean_1 } from '../../../_chunks/dep-6dd0e2df.mjs';
import { p as pick_1 } from '../../../_chunks/dep-9c5bd9e6.mjs';
import { o as omit_1 } from '../../../_chunks/dep-219a3220.mjs';
import log from '../log/log.mjs';
import '../../../_chunks/dep-ae1abe1d.mjs';
import '../../../_chunks/dep-eba62589.mjs';
import '../../../_chunks/dep-7d9e11c8.mjs';
import '../../../_chunks/dep-a6022780.mjs';
import '../../../_chunks/dep-30c9b83d.mjs';
import '../../../_chunks/dep-b9567f6a.mjs';
import '../../../_chunks/dep-654b4b01.mjs';
import '../../../_chunks/dep-06221fe2.mjs';
import '../../../_chunks/dep-8f44163a.mjs';
import '../../../_chunks/dep-a255de71.mjs';
import '../../../_chunks/dep-8d19eb1a.mjs';
import '../../../_chunks/dep-16e2f1a5.mjs';
import '../../../_chunks/dep-ebe8bc2f.mjs';
import '../../../_chunks/dep-cc371884.mjs';
import '../../../_chunks/dep-94585de3.mjs';
import '../../../_chunks/dep-f2586304.mjs';
import '../../../_chunks/dep-1f0070bb.mjs';
import '../../../_chunks/dep-9d0d32fd.mjs';
import '../../../_chunks/dep-e05e20e6.mjs';
import '../../../_chunks/dep-ebfafd52.mjs';
import '../../../_chunks/dep-750294df.mjs';
import '../../../_chunks/dep-f7eab885.mjs';
import '../../../_chunks/dep-67dfe9c7.mjs';
import '../../../_chunks/dep-1041f7d7.mjs';
import '../../../_chunks/dep-bd3d75f1.mjs';
import '../../../_chunks/dep-2b8d75e2.mjs';
import '../../../_chunks/dep-a11a63ea.mjs';
import '../../../_chunks/dep-ad1accf9.mjs';
import '../../../_chunks/dep-3e3494dc.mjs';
import '../../../_chunks/dep-42be3824.mjs';
import '../../../_chunks/dep-0fa7026c.mjs';
import '../../../_chunks/dep-b32fb318.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function getExposedProps(node) {
  var props = pick_1(node, ["value", "label", "data", "actived", "expanded", "checked", "indeterminate", "loading"]);
  return props;
}
function createNodeModel(node) {
  var props = getExposedProps(node);
  var model = _objectSpread(_objectSpread({}, props), {}, {
    getLevel: function getLevel() {
      return node.getLevel();
    },
    getIndex: function getIndex() {
      return node.getIndex();
    },
    isFirst: function isFirst() {
      return node.isFirst();
    },
    isLast: function isLast() {
      return node.isLast();
    },
    isLeaf: function isLeaf() {
      return node.isLeaf();
    },
    insertBefore: function insertBefore(newData) {
      return node.insertBefore(newData);
    },
    insertAfter: function insertAfter(newData) {
      return node.insertAfter(newData);
    },
    appendData: function appendData(data) {
      return node.append(data);
    },
    getPath: function getPath() {
      var nodes = node.getPath();
      return nodes.map(function (item) {
        return item.getModel();
      });
    },
    getParent: function getParent() {
      var _node$parent;
      return (_node$parent = node.parent) === null || _node$parent === void 0 ? void 0 : _node$parent.getModel();
    },
    getParents: function getParents() {
      var nodes = node.getParents();
      return nodes.map(function (item) {
        return item.getModel();
      });
    },
    getRoot: function getRoot() {
      var root = node.getRoot();
      return root === null || root === void 0 ? void 0 : root.getModel();
    },
    getSiblings: function getSiblings() {
      var nodes = node.getSiblings();
      return nodes.map(function (item) {
        return item.getModel();
      });
    },
    getChildren: function getChildren(deep) {
      var childrenModel = false;
      var children = node.children;
      if (Array.isArray(children)) {
        if (children.length > 0) {
          if (deep) {
            var nodes = node.walk();
            nodes.shift();
            childrenModel = nodes.map(function (item) {
              return item.getModel();
            });
          } else {
            childrenModel = children.map(function (item) {
              return item.getModel();
            });
          }
        } else {
          childrenModel = false;
        }
      } else if (isBoolean_1(children)) {
        childrenModel = children;
      }
      return childrenModel;
    },
    remove: function remove(value) {
      if (!value) {
        node.remove();
        return;
      }
      var tree = node.tree;
      var targetNode = tree.getNode(value);
      if (!targetNode) {
        log.warnOnce("Tree", "`".concat(value, "` is not exist"));
        return;
      }
      var parents = targetNode.getParents();
      var parentValues = parents.map(function (pnode) {
        return pnode.value;
      });
      if (parentValues.indexOf(node.value) < 0) {
        log.warnOnce("Tree", "`".concat(value, "` is not a childNode of current node"));
        return;
      }
      targetNode.remove();
    },
    setData: function setData(data) {
      var _data = omit_1(data, ["children", "value", "label"]);
      var keys = node.tree.config.keys;
      var dataValue = data[(keys === null || keys === void 0 ? void 0 : keys.value) || "value"];
      var dataLabel = data[(keys === null || keys === void 0 ? void 0 : keys.label) || "label"];
      if (!isUndefined_1(dataValue)) _data.value = dataValue;
      if (!isUndefined_1(dataLabel)) _data.label = dataLabel;
      Object.assign(node.data, _data);
      Object.assign(node, _data);
    }
  });
  return model;
}
function updateNodeModel(model, node) {
  var props = getExposedProps(node);
  Object.assign(model, props);
}

export { createNodeModel, updateNodeModel };
//# sourceMappingURL=tree-node-model.mjs.map
